import { IMAStrategy } from "../types/MAStrategy";

export const initialMaStrategyOverview: IMAStrategy = {
    intentions: "",
    acquisition: "",
    challenge: "",
    acquisitionBudget: "",
    mainAcquisition: ""
};